import React from 'react'
import cx from 'classnames'
import styles from './Tile.module.scss'

export const Tile = ({ label, selected = false, onClick }) => {
  return (
    <div
      className={cx(styles.container, {
        [styles.selected]: selected,
      })}
      onClick={onClick}
    >
      <span className={styles.label}>{label}</span>
    </div>
  )
}
